module.exports = __webpack_public_path__ + "49ac733d0ee85191f3afe1b636903e01.MP3";